var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.70092 7.83314C8.22707 8.28333 7.48334 8.28256 7.01044 7.83137L1.189 2.27735C0.813828 1.91941 0.813828 1.32059 1.189 0.962654C1.54068 0.627131 2.09414 0.627831 2.44497 0.964242L7.00858 5.34032C7.48192 5.79421 8.22866 5.79516 8.70315 5.34246L13.2647 0.990442C13.6158 0.655495 14.1681 0.655495 14.5192 0.990442C14.8949 1.34894 14.8943 1.94889 14.5178 2.3066L8.70092 7.83314Z",
    fill: "#3A74F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f05fd74174e6fa99133e003d8afd7e57.svg";
export { ForwardRef as ReactComponent };